/* eslint-disable */
import React, { Component } from 'react'


import Svg,{
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,
 
  Use,
  Defs,
  Stop
} from 'react-native-svg';

/*
original
<Svg
    height = {20}
    width = {20}
    viewBox="0 0 44 34" >
    <Defs></Defs>
<G id="WALL" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <G id="Group-2" transform="translate(-1.000000, -1.000000)" fill="#48526D">
        <Rect id="Rectangle-1-Copy-4" transform="translate(25.000000, 18.500000) rotate(-360.000000) translate(-25.000000, -18.500000) " x="5" y="15" width="40" height="7" rx="3.5"></Rect>
        <Rect id="Rectangle" transform="translate(11.573921, 11.829778) rotate(-45.000000) translate(-11.573921, -11.829778) " x="-0.926078911" y="8.32977841" width="25" height="7" rx="3.5"></Rect>
        <Rect id="Rectangle-Copy" transform="translate(11.532671, 24.894478) rotate(-315.000000) translate(-11.532671, -24.894478) " x="-0.967329202" y="21.3944785" width="25" height="7" rx="3.5"></Rect>
    </G>
</G>

</Svg>
*/

export const SvgBackButton = () => {
    return (  <Svg
        height = {20}
        width = {20}
        viewBox="0 0 44 34" >
        <Defs></Defs>
    <G id="WALL" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <G id="Group-2" transform="translate(-1.000000, -1.000000)" fill="#000000">
            <Rect id="Rectangle-1-Copy-4" transform="translate(25.000000, 18.500000) rotate(-360.000000) translate(-25.000000, -18.500000) " x="5" y="15" width="40" height="7" rx="3.5"></Rect>
            <Rect id="Rectangle" transform="translate(11.573921, 11.829778) rotate(-45.000000) translate(-11.573921, -11.829778) " x="-0.926078911" y="8.32977841" width="25" height="7" rx="3.5"></Rect>
            <Rect id="Rectangle-Copy" transform="translate(11.532671, 24.894478) rotate(-315.000000) translate(-11.532671, -24.894478) " x="-0.967329202" y="21.3944785" width="25" height="7" rx="3.5"></Rect>
        </G>
    </G>
    
    </Svg>)
}

